import React from 'react';
import * as DiagnosticsService from '@modules/diagnostics/service';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/function';
import { getPageInitialProps, HttpResult } from '@core/http';
import { NextPageWithLayout } from 'next';
import { renderHttpResult } from '@shared/utils/render';
import { sequenceS } from 'fp-ts/Apply';
import { getStringQuery, queryToHttpTask } from '@shared/utils/queries';
import { Diagnostic, DiagnosticsStepDetail } from '@modules/diagnostics/model';
import DiagnosticsSteps from '@modules/diagnostics/components/steps/DiagnosticsSteps';

interface StepsPageProps {
  diagnostics: Diagnostic;
  steps: DiagnosticsStepDetail;
}

const StepsPage: NextPageWithLayout<HttpResult<StepsPageProps>> = res =>
  renderHttpResult(res, ({ diagnostics, steps }) => <DiagnosticsSteps diagnostics={diagnostics} steps={steps} />);

StepsPage.getLayoutProps = () => ({ headerLight: true });

StepsPage.getInitialProps = getPageInitialProps(ctx =>
  pipe(
    sequenceS(TE.ApplyPar)({
      diagnosticNumber: queryToHttpTask(getStringQuery(ctx.query, 'diagnostic_number')),
      stepId: queryToHttpTask(getStringQuery(ctx.query, 'step_id')),
    }),
    TE.chain(({ diagnosticNumber, stepId }) =>
      sequenceS(TE.ApplyPar)({
        diagnostics: DiagnosticsService.getDiagnosticsDetail(diagnosticNumber),
        steps: DiagnosticsService.getDiagnosticsStepDetail(stepId),
      }),
    ),
  ),
);

export default StepsPage;
